import React, { createContext } from "react";

// Create the Form context
export const PcrUploadFormContext = createContext(null);
